import { Component, OnInit } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { CreateDiscussModalComponent } from '../create-discuss-modal/create-discuss-modal.component';

@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.css']
})
export class CreatePostComponent implements OnInit {

  closeResult = '';
  bsModalRef: BsModalRef;
  fileName: string;
  imageSrc: string;
  fileToUpload: File = null;
  userData:any;
  profileUrl ='';
  customProfileName='';
  colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];
  colorPick = '';
  supportText = 'Uploaded image format is not supported, please upload png/jpg/jpeg format images';
  showSupportText = false;

  constructor(private modalService: BsModalService) {}


  ngOnInit() {
    if (localStorage.getItem('userData')) {
      this.userData = JSON.parse(localStorage.getItem('userData'));
      if(this.userData.profile_pic && this.userData.profile_pic.indexOf('dummy-profile') == -1) {
        this.profileUrl = this.userData.profile_pic;
      } else {
        this.customProfileName = this.userData.first_name.charAt(0).toUpperCase() + this.userData.last_name.charAt(0).toUpperCase();
      //  this.customProfileName = 'UK';
        this.colorPick = this.colorPallete[Math.floor(Math.random() * 9)]
      }
    }
  }

  open() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
};
    this.bsModalRef = this.modalService.show(CreateDiscussModalComponent, ngbModalOptions);
  }

  fileChangeEventUpload(files: FileList){
    const allowed_types = ['image/png','image/jpg','image/jpeg'];
    let fileType =  files.item(0).type;
    if(allowed_types.includes(fileType)) {
      this.showSupportText = false;
      this.fileToUpload = files.item(0);
      this.fileName = this.fileToUpload.name;
      this.setpreviewImage();
    } else {
      this.showSupportText = true;
    }
  }
  setpreviewImage() {
    const reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = () => {
      this.imageSrc = reader.result as string;
    };
  }

  removeFile() {
    this.fileName = '';
  }



}
